import { cssVar } from 'utils/css';

export const backdrop = {
  root: {
    backgroundColor: cssVar('--modal-background'),
  },
};
